module.exports = __webpack_public_path__ + "nm-icons_0bfaa67614d37c25ad6f6a8877152021.ttf?d0080d90bd9c416987ebd7e8d4571a63";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_0bfaa67614d37c25ad6f6a8877152021.ttf
// module id = 1394
// module chunks = 35